"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpotOrdersController = void 0;
const constants_1 = require("../config/constants");
const market_1 = require("../data/market");
const spot_1 = require("../data/spot");
const rest_1 = require("../network/rest");
const WsBinanceClient_1 = require("../network/WsBinanceClient");
const binance_1 = require("../types/binance");
const spot_2 = require("../utils/data/spot");
const spot_3 = require("../utils/dataMappers/spot");
const formatted_1 = require("../utils/eventFilters/formatted");
const misc_1 = require("../utils/misc");
const shared_1 = require("./shared");
class SpotOrdersController extends shared_1.OrdersController {
    constructor(params) {
        super(params);
        this.defaultSubscriptionPairs = [{
                pair: 'BTCUSDT',
                baseAsset: 'BTC',
                quoteAsset: 'USDT'
            }];
        this.createQuotePairs = (params) => {
            return (0, misc_1.createUsdtQuotePair)(params);
        };
        this.getBalances = (params) => __awaiter(this, void 0, void 0, function* () {
            return SpotOrdersController.getBalances(params);
        });
        this.subscribeDueToData = (pairsToSubscribe, pairsToUnsubscribe) => {
            this.wsClient.unsubscribeIndividualTickerStream(pairsToUnsubscribe.map(pair => pair.pair));
            this.wsClient.subscribeIndividualTickerStream(pairsToSubscribe.map(pair => pair.pair));
        };
        const { ordersList, userBalance, exchangeInfo, restClient, symbolPriceTicker = [] } = params;
        this.marketTickers = symbolPriceTicker;
        this.marketDataInstance = new market_1.MarketDataSpot(Object.assign({ exchangeInfo }, (symbolPriceTicker.length > 0 ? {
            marketAssets: new Map(Object.entries((0, misc_1.priceTickerToMarketAsset)(symbolPriceTicker, exchangeInfo)))
        } : {})));
        userBalance.update({
            marketData: this.marketDataInstance.data
        });
        this.ordersList = ordersList;
        this.userBalance = userBalance;
        this.exchangeInfo = exchangeInfo;
        this.restClient = restClient;
    }
    setInitialSubscriptions() {
        //initial price subscription
        const pairsToSubscribe = this.createQuotePairs({
            assetIds: this.userBalance.assetIds,
            exchangeInfo: this.exchangeInfo
        });
        this.wsClient.subscribeIndividualTickerStream([...pairsToSubscribe.quotes, ...pairsToSubscribe.inverse].map(pair => pair.pair));
    }
    static load(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { ordersListParams, wsParams, userBalance, restClientParams, cacheManager } = params;
            const [restClient] = yield Promise.all([
                rest_1.RestBinanceSpotClient.load(restClientParams)
            ]);
            const [{ userBalanceFetched, exchangeInfo, ordersList, tickersPrice }, wsClient] = yield Promise.all([SpotOrdersController.getInitialData(Object.assign(Object.assign({}, params), { restClient })),
                WsBinanceClient_1.WsBinanceClient.load(wsParams)]);
            return new SpotOrdersController({
                ordersList,
                wsClient,
                restClient,
                userBalance: userBalance || userBalanceFetched,
                exchangeInfo,
                symbolPriceTicker: tickersPrice,
                cacheManager
            });
        });
    }
    static getInitialData(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { restClient, ordersListParams, cacheManager } = params;
            let cachedData = undefined;
            if (cacheManager)
                cachedData = yield cacheManager.get(constants_1.CACHE_SELECTORS.spotExchange);
            const exchangeInfo = cachedData ? cachedData : (yield restClient.getExchangeInfoRaw()).data;
            if (cacheManager && cachedData === undefined)
                yield cacheManager.set(constants_1.CACHE_SELECTORS.spotExchange, exchangeInfo);
            const [ordersList, userBalances, tickersPrice] = yield Promise.all([spot_1.SpotOrderList.load(Object.assign(Object.assign({}, ordersListParams), { fetchOrders: () => __awaiter(this, void 0, void 0, function* () {
                        try {
                            const orders = yield restClient.getOpenOrdersRaw({});
                            return orders.data.map(spot_3.spotOrderRawToSpotOrderMapper);
                        }
                        catch (_b) {
                            return [];
                        }
                    }) })), SpotOrdersController.getBalances({
                    restClient
                }),
                restClient.getSymbolPriceTicker()]);
            return {
                exchangeInfo: exchangeInfo,
                userBalanceFetched: userBalances.balances,
                ordersList,
                tickersPrice: tickersPrice.data
            };
        });
    }
    isHasUpdates(messages) {
        return {
            ordersMessages: [
                ...formatted_1.eventFormattedFiltersMap[binance_1.EWsBinanceSpotEventsTypes.executionReport](messages)
            ]
        };
    }
    startPolling() {
    }
    updateExchageInfo(exchangeInfo) {
        this.exchangeInfo = exchangeInfo;
        this.marketDataInstance.updateUnknownSymbols(new Map(Object.entries((0, misc_1.priceTickerToMarketAsset)(this.marketTickers, exchangeInfo))));
        this.setInitialSubscriptions();
    }
    clearCache() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.delFromCache(constants_1.CACHE_SELECTORS.spotExchange);
                return true;
            }
            catch (_b) {
                return false;
            }
        });
    }
    refreshCache() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.clearCache();
                const exchangeInfo = (yield this.restClient.getExchangeInfoRaw()).data;
                yield this.setToCache(constants_1.CACHE_SELECTORS.spotExchange, exchangeInfo);
                this.updateExchageInfo(exchangeInfo);
                return true;
            }
            catch (_b) {
                return false;
            }
        });
    }
    getExchangeInfo() {
        return this.exchangeInfo;
    }
}
exports.SpotOrdersController = SpotOrdersController;
_a = SpotOrdersController;
SpotOrdersController.getBalances = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { restClient } = params;
    const accountInformation = yield restClient.getAccountInformationRaw({});
    return {
        balances: spot_2.SpotDataUtils.createBalancesFromAccountInformation(accountInformation.data)
    };
});
